__turbopack_context__.v({
  "component": "style-module-scss-module__ElUCHW__component",
  "message": "style-module-scss-module__ElUCHW__message",
});
